var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-tree"},[_c('ritm-tree',{attrs:{"loading":_vm.loading,"tree-data":_vm.treeData,"mini-tools":"","node-click":_vm.nodeClick,"tool-click":_vm.toolClick,"tool-kit":_vm.toolKitByItem,"icon-by-item":_vm.iconByItem,"active-nodes":_vm.activeLayers,"loading-nodes":_vm.loadingLayers}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }